import { render, staticRenderFns } from "./SupportRequest.vue?vue&type=template&id=e254c89e&scoped=true&"
import script from "./SupportRequest.vue?vue&type=script&lang=js&"
export * from "./SupportRequest.vue?vue&type=script&lang=js&"
import style0 from "./SupportRequest.vue?vue&type=style&index=0&id=e254c89e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e254c89e",
  null
  
)

export default component.exports